import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { IoIosCalendar as CalendarIcon } from 'react-icons/io';
import { TiCancel as CancelIcon } from 'react-icons/ti';
import { GoPencil as UpdateIcon } from 'react-icons/go';
import CheckIcon from '../svgs/CheckIcon';
import PostOptionIcon from '../svgs/PostOptionIcon';
import InterestedIcon from '../svgs/InterestedIcon';
import Loading from '../Loading';
import styles from './EventDetail.module.css';
import ChatBox from '../chat/ChatBox';
import video_styles from '../chat/ChatBox.module.css';

import {
  MdLocationOn as LocationIcon,
  MdKeyboardArrowRight as AttendeesCountIcon,
} from 'react-icons/md';

import {
  logInterested,
  logGoing,
  logCheckIn,
  logAttendees,
  logCancelEvent,
  logShare,
  logAddress,
} from '../../../../shared/models/Analytics';
import {
  displayFullAddress,
  defaultEventPhoto,
  defaultUserPhoto,
  localizeDate,
  localizeTime,
} from '../../../../shared/utils/Helpers';

import CreatePostButton from '../feed/CreatePostButton';

import { rwbApi } from '../../../../shared/apis/api';

import { mergeAttendees } from '../../../../shared/utils/Helpers';

import { userProfile } from '../../../../shared/models/UserProfile';
import FeedList from '../feed/FeedList';
import { ATTENDANCE_SLUGS } from '../../../../shared/constants/AttendanceSlugs';
import CreateEvent from './CreateEvent';
import VirtualEventIcon from '../svgs/VirtualEventIcon';
import AttendingIcon from '../svgs/AttendingIcon';
import GoogleMapView from '../GoogleMapView';
import { hasReachedBottom } from '../../BrowserUtil';
import { EVENT_ERRORS, REPORT_ERROR, REPORT_SENT } from '../../../../shared/constants/ErrorMessages';
import AvatarList from '../AvatarList';
import { getDisplayDate, isEventOver, isVirtualEventJoinable } from '../../../../shared/utils/EventHelpers';
import DetailHeader from '../DetailHeader';
import RankingRow from '../challenges/RankingRow';
import ChevronRightIcon from '../svgs/ChevronRightIcon';
import CreatePost from '../feed/CreatePost';
import { getChallengeStatusText } from '../../../../shared/utils/ChallengeHelpers';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { isDev } from '../../../../shared/utils/IsDev';
import { CSVLink } from "react-csv";
import DocumentIcon from '../svgs/DocumentIcon';
import VideoPlayerWithChat from '../video/VideoPlayerWithChat';

const EventDetail = ({ refreshEvents }) => {
  const { eventId } = useParams();
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [totalAttendees, setTotalAttendees] = useState([]);
  const [total_count, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [retrievedLastPost, setRetrievedLastPost] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');
  const [eventData, setEventData] = useState({
    name: '',
    host: '',
    chapter_hosted: '',
    chapter_name: '',
    location: '',
    start: '',
    end: '',
    category: '',
    links: [],
    status: null,
    challenge_id: 0,
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [eventFeed, setEventFeed] = useState([]);
  const [userDataAttendance, setUserDataAttendance] = useState(null); // the data from the user returned by getAllAttendees will be kept here, so we don't have to call that function every time the status change
  const [mapShown, setMapShown] = useState(false);
  const [isRemoved, setIsRemoved] = useState(null);
  const [optionsOverlayVisible, setOptionsOverlayVisible] = useState(false);
  const [workoutState, setWorkoutState] = useState({
    workoutRecorded: false,
    miles: 0,
    steps: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [requiredUnit, setRequiredUnit] = useState('');
  const [challengeEndDate, setChallengeEndDate] = useState('');
  const [challengeStartDate, setChallengeStartDate] = useState('');
  const [challengeName, setChallengeName] = useState('');
  const [rank, setRank] = useState('');
  const [progress, setProgress] = useState('');

  const user = userProfile.getUserProfile();
  const history = useHistory();
  const location = useLocation();
  const [isVirtualEvent, setIsVirtualEvent] = useState(false)
  const [utcStartDateTime, setutcStartDateTime] = useState("")
  const [utcEndDateTime, setutcEndDateTime] = useState("")
  const [isEventTodayOrAfter, setEventTodayOrAfter] = useState(false)
  const [joinLiveVirtualEventLink, setJoinLiveVirtualEventLink] = useState("")
  const [recordedSessionLink, setRecordedSessionLink] = useState("")
  const [chatFileLink, setChatFileLink] = useState("")
  const [recordedFileLink, setRecordedFileLink] = useState("")
  const [virtualEventJoinable, setIsVirtualEventJoinable] = useState(false)
  const [maxAttendees, setMaxAttendees] = useState(0);
  const [isEventFull, setIsEventFull] = useState(false);
  const [csvData, setCSVData] = useState([]);
  const csvBtnRef = useRef();
  const isHostOrCreator = eventData?.host?.id === user.id || eventData?.creator?.id === user.id;


  useEffect(() => {
    loadEventDetails();
    getAttendanceStatus();
    getFeed(eventId);
    const getAttendees = (attempt) => {
      if (attempt >= 3) {
        alert(
          'There was a problem with the server. Some event attendees will not be displayed.',
        );
        return;
      }

      getAllAttendees();
    };

    getAttendees(attempt);
  }, [eventId, isUpdate]);

  let attempt = 0;

  const loadMorePosts = () => {
    // only try to retrieve more from the feed if it is not already retrieving
    if (!isLoadingMore) {
      const posts = eventFeed;
      const lastPost = posts[posts.length - 1];
      setIsLoadingMore(true);
      if (!retrievedLastPost) {
        if (!eventData.id || !lastPost?.id) return;
        rwbApi.getEventFeed(eventData.id, lastPost.id).then((result) => {
          if (result.data.results.length > 0) {
            setEventFeed([...eventFeed, ...result.data.results]);
            setIsLoadingMore(false);
          } else {
            setIsLoadingMore(false);
            setRetrievedLastPost(true);
          }
        });
      } else setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);
    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [loadMorePosts]);

  useEffect(() => {
    if (eventData?.challenge_id !== 0 && eventData?.challenge_id !== undefined) {
      loadWorkout(eventId);
      loadChallengeAndRank(eventData?.challenge_id);
    }
    let virtualEventJoinable = false;
    virtualEventJoinable = isVirtualEventJoinable({
      utcStartDateTime: moment.utc(eventData.start),
      utcEndDateTime: moment.utc(eventData.end)
    });
    setIsVirtualEventJoinable(virtualEventJoinable)
    setIsVirtualEvent(eventData.is_virtual)
    setutcStartDateTime(moment.utc(eventData.start))
    setutcEndDateTime(moment.utc(eventData.end))
    setEventTodayOrAfter(moment().isSameOrAfter(moment.utc(eventData.start), 'date'))
    setJoinLiveVirtualEventLink(getJoinLiveVirtualEventLink(eventData.links))
    setRecordedSessionLink(getRecordedSessionLink(eventData.links))
    setChatFileLink(getChatFileLink(eventData.links))
    setRecordedFileLink(getRecordedFileLink(eventData.links))

  }, [eventData]);
  const loadAttendees = (eventID) => {
    rwbApi.getAllMobileAttendees(eventID).then((res) => {

      let going;
      let checked_in;
      let interested;
      const numberOfUsers =
        res.going.count +
        res.checked_in.count +
        res.interested.count;
      if (res.going) going = res.going.attendees;
      if (res.checked_in) checked_in = res.checked_in.attendees;
      if (res.interested) interested = res.interested.attendees;


      setIsEventFull((eventData.max_attendees != null && (going?.length + checked_in?.length) >= eventData.max_attendees))

    }).catch((error) => {
      errorAlert(EVENT_ERRORS.ATTENDESS);
    });
  }
  useEffect(() => {
    if (location.state?.refreshEvents === true) {
      refreshEvents();
    }
  }, []);

  const getFirstZoomLink = (links) => {
    for (let i = 0; i < links.length; i++) {
      if (links[i].url.toLowerCase().includes('zoom.us')) {
        return links[i].url;
      }
    }
    return null;
  }

  const getJoinLiveVirtualEventLink = (links) => {
    // "Join Live Event" is hardcoded string in the FitPros airtable, Social Stack Backend, and here. See c12869bf3566 / D7737.
    // Current whitelabeling strategy: First, look for `Join Live Event`. If not found, look for the first zoom link.
    // The assumption here is that it's always ok to launch the 'Join Live Event' or First zoom link when the event is live.
    // This results in some hidden features from a event-creator perspective. Improvements discussed in T5793.
    for (let i = 0; i < links.length; i++) {
      if (links[i].text.includes('Join Live Event')) {
        return links[i].url;
      }
    }
    return getFirstZoomLink(links);
  }

  const getRecordedSessionLink = (links) => {
    let watchRecordedLinktext = e => e.text === "Start Recorded Session";
    let watchRecordedLinkElement = links.find(watchRecordedLinktext)
    return watchRecordedLinkElement?.url || null;
  }
  
  const getRecordedFileLink = (links) => {
    for (let i = 0; i < links.length; i++) {
      if (links[i].text.includes('Video File'))
        return links[i].url;
    }
    return false;
  }

  const getChatFileLink = (links) => {
    for (let i = 0; i < links.length; i++) {
      if (links[i].text.includes('Chat File'))
        return links[i].url;
    }
    return false;
  }

  const loadWorkout = (id) => {
    rwbApi
      .getWorkout(id)
      .then((result) => {
        if (result.data?.event_id != 0) {
          const hours = Math.floor(result.data.minutes / 60);
          const minutes = Math.floor(result.data.minutes % 60);
          const seconds = Math.round((result.data.minutes % 1) * 60);
          setWorkoutState({
            workoutRecorded: true,
            miles: result.data.miles,
            steps: result.data.steps,
            hours,
            minutes,
            seconds,
          });
        }
      })
      .catch((err) => {
        errorAlert(EVENT_ERRORS.LOADING_WORKOUT);
      });
  };

  const loadChallengeAndRank = (id) => {
    const loadChallenge = rwbApi.getChallenge(id);
    const loadRank = rwbApi.getLeaderboardRank(id);
    Promise.all([loadChallenge, loadRank])
      .then(([challenge, rank]) => {
        setRequiredUnit(challenge.required_unit);
        setChallengeEndDate(challenge.end_date);
        setChallengeStartDate(challenge.start_date);
        setChallengeName(challenge.name);
        setRank(rank.rank);
        setProgress(rank.score);
        setLoading(false);
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const trackScrolling = (event) => {
    event.preventDefault();
    const wrappedElement = document.getElementById('root');
    if (hasReachedBottom(wrappedElement)) {
      loadMorePosts();
    }
  };

  const getAllAttendees = () =>
    rwbApi
      .getAllMobileAttendees(eventId)
      .then((data) => {
        if (data) {
          const { mergedAttendees, totalCount } = mergeAttendees(data);
          if (!userDataAttendance) {
            const userData = mergedAttendees.find((el) => el.id === user.id);
            if (userData) setUserDataAttendance(userData);
          }
          setTotalAttendees(mergedAttendees);
          setTotalCount(totalCount);
          // setLoading(false);
        }
      })
      .catch((error) => {
        if (attempt < 3) {
          console.warn('error', error);
        }
        setLoading(false);
      });

  const getAttendanceStatus = () => {
    rwbApi.getMobileAttendanceStatus(eventId).then((status) => {
      if (!status) return;
      setAttendanceStatus(status.status);
    });
  };

  const loadEventDetails = () => {
    rwbApi.getMobileEvent(eventId).then((response) => {
      setEventData(response);
      setIsRemoved(response.is_removed);
      loadAttendees(eventId)
      if (response.is_removed) {
        errorAlert(EVENT_ERRORS.CANCELED_AND_REMOVED);
        history.push('/events');
        refreshEvents();
      }
      if (!response.challenge_id || response.challenge_id === '')
        setLoading(false);
    });
  };

  const getFeed = (eventID) => {
    // prepending the most recent result mixes up reactions
    // to avoid that, clear out everything and reload everything
    const currentFeed = eventFeed;
    setEventFeed([]);
    return rwbApi
      .getEventFeed(eventID)
      .then((result) => {
        setEventFeed(result.data.results);
      })
      .catch((error) => {
        console.warn('error getting feed: ', error);
        setEventFeed(currentFeed);
        alert('There was an error retrieving the event feed.');
      });
  };

  const mergeNewPost = (newPost) => {
    // Not returning user data and breaks the app
    // setEventFeed((oldPosts) => [...oldPosts, newPost]);
    getFeed(eventId);
  };

  const deleteAttendanceStatus = async () => {
    const prevAttendance = attendanceStatus;
    setAttendanceStatus('none');

    if (userDataAttendance) {
      const filteredAttendees = totalAttendees.filter(
        (attendee) => attendee.id !== userDataAttendance.id,
      );
      setTotalAttendees(filteredAttendees);
    }

    const result = await rwbApi.updateMobileAttendanceStatus(eventId, 'none');
    if (!result) setAttendanceStatus(prevAttendance);
    if (result) setTotalCount(total_count - 1);
    if (!userDataAttendance) {
      getAllAttendees();
    }
  };

  const updateAttendanceStatus = async (id, status) => {
    setAttendanceStatus(status);
    if (status === ATTENDANCE_SLUGS.interested) logInterested();
    if (status === ATTENDANCE_SLUGS.going) logGoing();
    if (status === ATTENDANCE_SLUGS.checkedin) logCheckIn();

    // The code for instant adding user to attendees list, before an API call because the old way was slow
    if (userDataAttendance) {
      if (attendanceStatus !== status) {
        const filteredAttendees = totalAttendees.filter(
          (attendee) => attendee.id !== userDataAttendance.id,
        );
        setTotalAttendees([...filteredAttendees, userDataAttendance]);
      } else {
        setTotalAttendees([...totalAttendees, userDataAttendance]);
      }
      if (attendanceStatus === 'none') setTotalCount(total_count + 1);
    }
    const result = await rwbApi.updateMobileAttendanceStatus(id, status);
    if (!result) setAttendanceStatus('none');

    if (!userDataAttendance) getAllAttendees();
  };

  const setInitialAttendanceStatus = async (status) => {
    setAttendanceStatus(status);
    const result = await rwbApi.setInitialMobileAttendanceStatus(
      eventId,
      status,
    );
    if (!result) return setAttendanceStatus('none');
    getAllAttendees();
  };

  const eventStatusHandler = (e, status) => {
    if (!attendanceStatus) return setInitialAttendanceStatus(status);

    if (status === ATTENDANCE_SLUGS.going) {
      if (attendanceStatus === ATTENDANCE_SLUGS.going)
        return deleteAttendanceStatus();
      updateAttendanceStatus(eventId, status);
    } else if (status === ATTENDANCE_SLUGS.interested) {
      if (attendanceStatus === ATTENDANCE_SLUGS.interested) {
        return deleteAttendanceStatus();
      }
      updateAttendanceStatus(eventId, status);
    } else if (status === ATTENDANCE_SLUGS.checkedin) {
      if (e!=null && e.currentTarget.id === "checkInToggleButton" && attendanceStatus === ATTENDANCE_SLUGS.checkedin)
        // Only the check in toggle button can toggle the check in status off
        return deleteAttendanceStatus();
      updateAttendanceStatus(eventId, status);
    }
  };

  const handleEventLinkClick = (url) => {
    // if the link is joinLiveVirtualEventLink, run eventStatusHandler then open the link
    if ((url === joinLiveVirtualEventLink || url === recordedSessionLink || url === chatFileLink || url === recordedFileLink) && virtualEventJoinable) {
      eventStatusHandler(null, ATTENDANCE_SLUGS.checkedin);
    }
    window.open(url, '_blank', 'noopener');
  }

  const copyEventURL = () => {
    logShare();
    const urlBase = isDev() ? projectConfig.stagingURL : projectConfig.prodURL;
    navigator.clipboard.writeText(
      `${urlBase}events/${eventId}`,
    );
    setCopyMessage('Copied!');
    setTimeout(() => {
      setCopyMessage('');
    }, 3000);
  };

  const getAddress = () =>
    displayFullAddress(
      eventData.location.address,
      eventData.location.city,
      eventData.location.state,
      eventData.location.zip,
      eventData.location.country,
    );

  const cancelEventHandler = () => {
    if (window.confirm('Are you sure you want to cancel this event?')) {
      const payload = {
        status: 'Canceled',
      };
      setLoading(true);
      rwbApi
        .patchEvent(eventId, JSON.stringify(payload))
        .then(() => {
          logCancelEvent();
          // updating a field in the object does not force a rerender, so save nothing and then the updated object
          let updatedEventData = eventData;
          updatedEventData.status = 'Canceled';
          setEventData(updatedEventData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.warn('Error canceling the event: ', error);
        });
    }
  };

  const removeEventHandler = () => {
    if (
      window.confirm(
        'Are you sure you want to remove event from the event list?',
      )
    ) {
      rwbApi
        .removeEvent(eventId)
        .then(() => {
          history.push('/events');
          refreshEvents();
        })
        .catch((error) => {
          console.warn('Error removing the event: ', error);
        });
    }
  };

  const isEventTodayOrBefore = () => {
    const today = moment();
    const eventDate = localizeDate(
      eventData.start,
      eventData.time_zone_id,
      eventData.start,
    );
    const localOffset = today.utcOffset();
    let compareDate;
    // Even after localizing the start time, the moment object has it saved as a UTC time
    // this means that when we do a comparison with it, additional time will be added/subtracted.
    // That could modify the date which affects checking in and allow early check in.
    // To compensate for how moment works, we add (subtract the negative) minute offset for local time
    if (eventData.is_all_day && localOffset < 0)
      compareDate = moment(eventDate).subtract(localOffset, 'minutes');
    else compareDate = eventDate;
    // enable check in for all events is the user's local device has the same date or is later than the localized start time
    return today.isSameOrAfter(compareDate, 'date');
  };

  const updateEventHandler = () => setIsUpdate(true);

  const addressClickHandler = () => {
    logAddress();
    setMapShown((prevState) => !prevState);
  };

  const reportEvent = () => {
    if (window.confirm(`${projectConfig.alertTitle}: Would you like to report this event?`)) {
      const reporterUserID = JSON.stringify({ reporter: user.id });
      rwbApi
        .reportEvent(eventId, reporterUserID)
        .then(() => {
          errorAlert(REPORT_SENT);
        })
        .catch((err) => {
          errorAlert(REPORT_ERROR);
          console.warn(err);
        });
    }
  };

  const [createPostModal, setCreatePostModal] = useState(false);

  const openCloseModalHandler = () =>
    setCreatePostModal((prevState) => !prevState);

  const onWorkoutDelete = () => {
    if (window.confirm('Are you sure you want to delete this workout?')) {
      setLoading(true);
      rwbApi
        .deleteWorkout(eventId)
        .then(() => {
          rwbApi.getLeaderboardRank(eventData.challenge_id).then((rank) => {
            setRank(rank.rank);
            setProgress(rank.score);
          });
          setWorkoutState({
            workoutRecorded: false,
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setOptionsOverlayVisible();
    }
  };

  const handleGoBack = () => {
    return location.state?.from === 'record-workout'
      ? history.push(location.state.eventFrom)
      : history.goBack();
  };
  const renderEventLinks = (eventLinks) => {
    // text={links[i].text}
    // url={links[i].url}
    // key={i.toString()}
    let linkObjs = [];
    for (let i = 0; i < eventLinks.length; i++) {
      linkObjs.push(
        <a href={eventLinks[i].url}>{eventLinks[i].text}</a>
      );
    }
    return linkObjs
  }


  const downloadCSV = () => {
    rwbApi
      .getAllMobileAttendeesCsv(eventId)
      .then((result) => {
        const lines = result.split('\n');
        // Split each line into fields and create array of arrays
        const data = lines.map(line => line.split(','));
        setCSVData(data);
        setTimeout(() => {
          csvBtnRef.current.link.click()
        }, 200);

      })
      .catch((error) => {
        console.warn('error getting csv: ', error);
        errorAlert("CANNOT_GET_ATTENDEES_CSV");
        this.setState({
          attendanceStatusLoading: false,
        });
      });
  }

  return (

    <>
      {loading ? (
        <Loading size={100} color={'var(--white)'} loading={true} right />
      ) : (
        <>
          <DetailHeader
            imgAlt="Event Banner"
            primaryImg={eventData.photo_url}
            backupImg={defaultEventPhoto(
              eventData.category === 'virtual' ? 'virtual' : eventData.category,
              eventData?.name
            )}
            goBack={handleGoBack}
            copyClick={copyEventURL}
            copyMessage={copyMessage}
          />
          <div className={styles.contentContainer}>
            <div className={styles.eventNameAndReportContainer}>
              <div className={styles.eventNameAndChapterContainer}>
                <h1>{eventData.name}</h1>
                <h5 className={styles.chapterName}>{eventData.chapter?.name}</h5>
              </div>
              {/* {eventData.host.id !== userProfile.id ? (
                <div
                  className={styles.optionsContainer}
                  onClick={() => reportEvent()}
                  >
                  <PostOptionIcon height="24" width="24" />
                </div>
              ) : null} */}
            </div>
            <div className={styles.infoIconContainer}>
              <CalendarIcon />
              <div>
                <p>
                  {getDisplayDate(moment.utc(eventData.start))}
                  {moment().utc().isAfter(moment.utc(eventData.end)) && <span className={[styles.sessionEndedContainer]}>
                    {projectConfig.sessionEndedMessage.toUpperCase()}
                  </span>}
                </p>
                <p>
                  {!eventData.is_all_day
                    ? `${moment(moment.utc(eventData.start)).local().format(
                      'h:mm A',
                    )} – ${moment(moment.utc(eventData.end)).local().format('h:mm A')}`
                    : 'All Day Event'}
                </p>
              </div>
            </div>
            <div
              className={styles.eventHostContainer}
              onClick={() => history.push(`/profile/${eventData.host.id}`)}>
              <img
                className={styles.hostProfileImg}
                alt="Host Profile"
                src={eventData.host.profile_photo_url || defaultUserPhoto}
              />
              <div className={styles.hostDetails}>
                <h5 className={styles.hostTitle}>
                  {eventData.host.leader
                    ? projectConfig.leaderRoleDisplay
                    : ''}
                </h5>
                <div className="namesAndObjects">
                  {`${eventData.host.first_name} ${eventData.host.last_name}`}
                  {/* wait for server to inform if the event is a sponsor type and hosted by a sponsor admin */}
                  {/* <EagleLeaderIcon /> */}
                </div>
              </div>
            </div>
            <div className={styles.infoIconContainer}>
              {eventData.location.address ? (
                <>
                  <LocationIcon />
                  <p
                    className={`bodyCopy ${styles.clickable}`}
                    onClick={addressClickHandler}>
                    {getAddress()}
                  </p>
                </>
              ) : (
                <>
                  <VirtualEventIcon />
                  <p className={`bodyCopyForm ${styles.virtualEventCategory}`}>
                    Virtual{' '}
                    {eventData.virtual_event_category?.slice(0, -1) || 'Event'}
                    {/* virtual_event_category is in the plural, slice is used to cut the last letter */}
                  </p>
                </>
              )}
            </div>
            {mapShown && (
              <div className={styles.mapContainer}>
                <GoogleMapView
                  location={{
                    lat: eventData.location.latitude,
                    lng: eventData.location.longitude,
                  }}
                />
              </div>
            )}
            {eventData?.challenge_id && eventData?.challenge_id !== '0' ? (
              <Link to={`/challenges/${eventData.challenge_id}`}>
                <div className={styles.challengeInfoContainer}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                      }}>
                      <h2>{challengeName}</h2>
                      <h5>
                        {getChallengeStatusText(
                          challengeStartDate,
                          challengeEndDate,
                        )}
                      </h5>
                    </div>
                    <ChevronRightIcon />
                  </div>
                  {rank && rank !== '' && (
                    <RankingRow
                      place={rank}
                      progress={progress}
                      ignoreEmphasis={true}
                      metric={requiredUnit}
                      user={user}
                    />
                  )}
                </div>
              </Link>
            ) : null}

            {eventData.status === 'Canceled' ? (
              <div>
                <div className={styles.canceledEventContainer}>
                  <h4>This Event Has Been Canceled</h4>
                </div>
                {!isRemoved && isHostOrCreator ? (
                  <div
                    id="removeButton"
                    className={styles.removedEventContainer}
                    onClick={removeEventHandler}>
                    <h4>Remove Event from Event List</h4>
                  </div>
                ) : null}
              </div>
            ) : isHostOrCreator ? (
              // prevent modifying event after it is over
              moment(utcEndDateTime).isBefore(moment()) ? null : (
                <div className={styles.eventStatus}>
                  <div className={styles.buttonsContainer}>
                    <div
                      id="cancelButton"
                      className={`${styles.statusButton} ${styles.cancelButton}`}
                      onClick={cancelEventHandler}>
                      <CancelIcon />
                      <h4>Cancel</h4>
                    </div>
                    <div
                      id="updateButton"
                      className={`${styles.statusButton} ${styles.updateButton}`}
                      onClick={updateEventHandler}>
                      <UpdateIcon />
                      <h4>Update</h4>
                    </div>
                  </div>
                  {projectConfig.eventAttendeeListDownload &&
                    <>
                      <div className={`${styles.statusButton} ${styles.getAttendeeListButton}`} onClick={downloadCSV}>
                        <DocumentIcon tintColor={"#FFF"} />
                        <h4>Get Attendee List</h4>
                      </div>
                      <CSVLink id="downloadCsv" asyncOnClick={true}
                        data={csvData}
                        ref={csvBtnRef}
                        filename="attendees.csv">
                      </CSVLink>
                    </>
                  }
                </div>
              )
            ) :

              isVirtualEvent && joinLiveVirtualEventLink && virtualEventJoinable ?
                <div className={styles.buttonsContainerCheckedIn}>
                  <div
                    id="checkInButton"
                    className={`${styles.statusButton} ${attendanceStatus === ATTENDANCE_SLUGS.checkedin &&
                      styles.statusButtonClicked
                      }`}
                    aria-disabled={isEventFull && attendanceStatus !== ATTENDANCE_SLUGS.checkedin}
                    onClick={(e) => {
                      eventStatusHandler(e, ATTENDANCE_SLUGS.checkedin)
                      window.open(joinLiveVirtualEventLink, '_blank', 'noopener')
                    }

                    }>
                    <CheckIcon
                      tintColor={
                        attendanceStatus === ATTENDANCE_SLUGS.checkedin
                          ? 'var(--white)'
                          : 'var(--grey)'
                      }
                    />
                    <h4>
                      {isEventFull ? "Event Full" : attendanceStatus === ATTENDANCE_SLUGS.checkedin ? 'Join the Live Stream' : "Join the Live Stream & Check In"}
                    </h4>
                  </div>
                </div>

                :
                isVirtualEvent && recordedFileLink && moment().utc().isAfter(utcEndDateTime) ? (
                  <>
                    <div className={styles.infoIconContainer}>
                      {attendanceStatus !== ATTENDANCE_SLUGS.checkedin ? (
                        <>
                          <CheckIcon tintColor={'var(--grey40)'}/>
                          <p className={styles.bodyCopyName}>Watch recorded session to check in.</p>
                        </>
                      ) :
                        <>
                          <CheckIcon />
                          <p className={styles.bodyCopyName}>You checked in!</p>
                        </>
                      }
                    </div>
                    <div style={{ width: "100%", margin: '0 0 30px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <VideoPlayerWithChat source={recordedFileLink} chatLogUrl={chatFileLink}
                        onPlay={() => {
                          if (attendanceStatus !== ATTENDANCE_SLUGS.checkedin) {
                            eventStatusHandler(null, ATTENDANCE_SLUGS.checkedin);
                          }
                        }}/>
                    </div>
                  </>
                ) : 
                  (
                    <div className={styles.eventStatus}>
                      {!isVirtualEvent && isEventTodayOrAfter ? (
                        <div className={styles.buttonsContainerCheckedIn}>
                          <div
                            id="checkInToggleButton"
                            className={`${styles.statusButton} ${attendanceStatus === ATTENDANCE_SLUGS.checkedin &&
                              styles.statusButtonClicked
                              }`}
                            onClick={(e) =>
                              eventStatusHandler(e, ATTENDANCE_SLUGS.checkedin)
                            }>
                            <CheckIcon
                              tintColor={
                                attendanceStatus === ATTENDANCE_SLUGS.checkedin
                                  ? 'var(--white)'
                                  : 'var(--grey)'
                              }
                            />
                            <h4>
                              {isEventFull ? "Event Full" : attendanceStatus === ATTENDANCE_SLUGS.checkedin ? 'Checked In' : "Check In"}
                            </h4>
                          </div>
                        </div>
                      ) :
                        isVirtualEvent && moment(utcStartDateTime).isBefore(moment()) ? (
                          <div className={styles.buttonsContainerCheckedIn}>
                            <div
                              id="checkInToggleButton"
                              className={`${styles.statusButton} ${attendanceStatus === ATTENDANCE_SLUGS.checkedin &&
                                styles.statusButtonClicked
                                }`}
                              onClick={(e) =>
                                eventStatusHandler(e, ATTENDANCE_SLUGS.checkedin)
                              }>
                              <CheckIcon
                                tintColor={
                                  attendanceStatus === ATTENDANCE_SLUGS.checkedin
                                    ? 'var(--white)'
                                    : 'var(--grey)'
                                }
                              />
                              <h4>
                                {isEventFull ? "Event Full" : attendanceStatus === ATTENDANCE_SLUGS.checkedin ? 'Checked In' : "Check In"}
                              </h4>
                            </div>
                          </div>
                        )

                          :

                          (
                            <div className={styles.buttonsContainer}>
                              <div
                                id="goingButton"
                                className={`${styles.statusButton} ${styles.goingButton
                                  } ${attendanceStatus === ATTENDANCE_SLUGS.going &&
                                  styles.statusButtonClicked
                                  }`}
                                onClick={(e) =>
                                  eventStatusHandler(e, ATTENDANCE_SLUGS.going)
                                }>
                                {attendanceStatus === ATTENDANCE_SLUGS.going ? (
                                  <CheckIcon tintColor={'var(--white)'} />
                                ) : (
                                  <AttendingIcon tintColor={'var(--grey)'} />
                                )}

                                <h4>{projectConfig.eventRsvpLabel}</h4>
                              </div>
                              <div
                                id="interestedButton"
                                className={`${styles.statusButton} ${attendanceStatus === ATTENDANCE_SLUGS.interested &&
                                  styles.statusButtonClicked
                                  }`}
                                onClick={(e) =>
                                  eventStatusHandler(e, ATTENDANCE_SLUGS.interested)
                                }>
                                {attendanceStatus === ATTENDANCE_SLUGS.interested ? (
                                  <CheckIcon tintColor={'var(--white)'} />
                                ) : (
                                  <InterestedIcon tintColor={'var(--grey)'} />
                                )}
                                <h4>Interested</h4>
                              </div>
                            </div>
                          )}
                    </div>
                  )}

            <Link
              onClick={logAttendees}
              to={{
                pathname: `/events/${eventData.id}/attendees`,
                state: {
                  host: eventData.host,
                  date: eventData.start,
                  isVirtual: eventData.is_virtual,
                  timeZone: eventData.time_zone_id,
                },
              }}>
              <AvatarList avatars={totalAttendees} total_count={total_count} />
            </Link>
            <div className={styles.description}>{eventData.description}</div>
            <div className={styles.eventLinks}>
              <p className="link">Event Links:</p>
              {eventData.links !== null &&
                eventData.links.length > 0 &&
                eventData.links.map((link, i) => (
                  <div key={'linkContainer' + i}>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="#"
                      className="link"
                      key={'link' + i}
                      onClick={(e) => {
                        e.preventDefault();
                        handleEventLinkClick(link.url);
                      }}>
                      {link.text}
                    </a>
                  </div>
                ))}
            </div>
          </div>
          {eventFeed.length > 0 && (
            <>
              <FeedList
                userFeed={eventFeed}
                eventID={eventId}
                type={'post'}
                mergeNewPost={(newPost) => mergeNewPost(newPost)}
              />
            </>
          )}
          {!user.anonymous_profile && (
            <CreatePostButton
              type={'event'}
              eventID={eventId}
              mergeNewPost={(newPost) => mergeNewPost(newPost)}
            />
          )}
          {isUpdate && (
            <CreateEvent
              isChapterEvent={eventData?.chapter_hosted || eventData?.chapter?.id}
              eventData={eventData}
              closeModalHandlers={() => setIsUpdate(false)}
              refreshEvents={refreshEvents}
              groupId={eventData?.chapter_id || eventData?.chapter?.id}
              isVirtual={eventData.is_virtual}
            />
          )}
        </>
      )}

      {createPostModal && (
        <CreatePost
          type={'user'}
          eventID={eventId}
          groupID={eventData.chapter_id}
          challengeID={eventData.challenge_id}
          closeModalHandler={openCloseModalHandler}
          mergeNewPost={mergeNewPost}
          eventName={eventData.name}
          chapterName={eventData.chapter_name}
          eventStartTime={eventData.start}
          miles={workoutState.miles}
          steps={workoutState.steps}
          hours={workoutState.hours}
          minutes={workoutState.minutes}
          seconds={workoutState.seconds}
        />
      )}
    </>
  );
};

export default EventDetail;
